import axios from 'axios';

export default async function getPropertyDetails(propertyId) {
  try {
    if (propertyId !== undefined) {
      const results = await axios.get(
        `${process.env.REACT_APP_MCCC_API_URL}/refi/property/details/${propertyId}`,
      );
      return results;
    }
  } catch (error) {
    console.error(error);
    return error.response.status;
  }
}
